import { EstadoBeca } from '../model/enumerations/estado-beca.model';

export default function resolveEstadoBecaVariant(estado: EstadoBeca) {
  switch (estado) {
    case EstadoBeca.BAJA:
      return 'secondary';
    case EstadoBeca.CANCELADA:
      return 'danger';
    case EstadoBeca.NO_VIGENTE:
      return 'dark';
    case EstadoBeca.REANUDADA:
      return 'info';
    case EstadoBeca.RENUNCIA:
      return 'primary';
    case EstadoBeca.SUSPENDIDA:
      return 'warning';
    case EstadoBeca.VIGENTE:
      return 'success';
    default:
      return 'primary';
  }
}
